// extracted by mini-css-extract-plugin
export default {"incomeProofForm":"incomeProof_incomeProofForm__3ZW3x","incomeProofBox":"incomeProof_incomeProofBox__BdaE6"};